import React from 'react';

interface Props {
	text?: string | null;
	children?: React.ReactElement | null;
	fontFamily?: string;
	textColor?: string;
}

export const WidgetTitle = (props: Props): React.ReactElement => {
	const { text, children, textColor, fontFamily } = props;

	return (
		<h1 className="ui-widget-title" style={{ color: `${textColor}`, fontFamily: `${fontFamily}` }}>
			{children || text}
		</h1>
	);
};
